export default "__VITE_ASSET__BUrdb$4C__"